import React, { useState, createContext, useEffect, useRef } from 'react'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '../firebase.config'

const RoleContext = createContext({
  user: null,
  role: null,
  updateUser: () => {},
  updateRole: () => {},
})

export function RoleContextProvider(props) {
  const [user, setUser] = useState(null)
  const [role, setRole] = useState(null)
  const auth = getAuth()
  const isMounted = useRef(true)

  useEffect(() => {
    const fetchUser = async () => {
      const docRef = doc(db, 'users', auth.currentUser.uid)
      const docSnap = await getDoc(docRef)
      setUser(docSnap.data().name)
      setRole(docSnap.data().role)
    }
    if (isMounted) {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          fetchUser()
        }
        return () => {
          isMounted.current = false
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted])

  const contextValue = {
    user,
    role,
    updateUser: setUser,
    updateRole: setRole,
  }
  return (
    <RoleContext.Provider value={contextValue}>
      {props.children}
    </RoleContext.Provider>
  )
}

export default RoleContext
